/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Link as RRLink, LinkProps } from 'react-router-dom';

import { useCondensedQueryParameters } from 'hooks/useQueryParameters';
import { mergeLocation } from 'hooks/useNavigationHelpers';

import styles from './styles';

const Link: React.FC<LinkProps> = React.forwardRef<RRLink, LinkProps>(
  ({ to, ...linkProps }, ref) => {
    const params = useCondensedQueryParameters();
    to = mergeLocation(params, to);
    return <RRLink css={styles.link} to={to} {...linkProps} ref={ref} />;
  },
);

export default Link;
